import { gql } from '@apollo/client';
import { METRIC_RECORD_BASE_FIELDS } from '../fragments/metric_record.fragments';

export const GET_METRIC_RECORDS_FULL = gql`
  query GetMetricRecords($input: GetMetricRecordsRequest!) {
    getMetricRecords(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        ...MetricRecordBaseFields
        source
        proportion
        country
        region
        division
        subdivision
        site
        reporting_period
        reporting_period_group
        external_company
        emission_factor
        scope
        note
        status
        is_averaged
        import_id
      }
    }
  }
  ${METRIC_RECORD_BASE_FIELDS}
`;

export const GET_METRIC_RECORDS_REPORTING_LEVELS_ONLY = gql`
  query GetMetricRecords($input: GetMetricRecordsRequest!) {
    getMetricRecords(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        ...MetricRecordBaseFields
        country
        region
        division
        subdivision
        site
        reporting_period
      }
    }
  }
  ${METRIC_RECORD_BASE_FIELDS}
`;

export const GET_METRIC_RECORDS_QUALITATIVE = gql`
  query GetMetricRecords($input: GetMetricRecordsRequest!) {
    getMetricRecords(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        ...MetricRecordBaseFields
        status
        reporting_period_group
      }
    }
  }
  ${METRIC_RECORD_BASE_FIELDS}
`;
